export const deviceTypesInv = {
    TwigProtector: 4,
    TwigProtectorPro: 5,
    TwigProtectorEX: 6,
    TwigProtectorProEX: 9,
    TwigEmbody: 7,
    TwigSOSCard: 10,
    TwigProtectorProOld: 11,
    TeltonikaTMT250Old: 12,
    TeltonikaGH5200: 13,
    Generic: 14,
    App: 15,
    TeltonikaTMT250: 16,
    TwigOne: 17,
    WebUser: 18,
    MoxaE12010: 19,
    TwigNeo: 20,
    TwigOneEx: 21,
    EmeritEWG100: 22,
    ESPA: 23,
    TwigRemoteButton: 24,
    TwigSOSCardP5: 25,
    EviewEV04: 26,
    QueclinkGL320M: 27,
    TeltonikaFMC640: 28,
    TwigEasy5: 29,
    ESPA2: 30,
    TeltonikaFMC650: 31,
    EmeritConnect: 32,
    EmeritERG170: 33,
    EmeritERG530: 34,
    EmeritERG650: 35,
    EmeritERG655: 36,
    EmeritEIS330: 37,
    EmeritEIS530: 38,
    EmeritEIS655: 39,
    TwigEasy4: 40,
    TwigEon: 41,
    TwigNeoEx: 42,
    EmeritEWG200: 43,
    EmeritERG360: 44,
    MobileAppLite: 45,
    // V4-only hardware — no V3 backend, so these ids are ours (see v4OnlyDeviceTypes).
    EviewEV06: 46,
    EviewEV12: 47,
    // V4-only too, but these ids come from the device-type registry itself.
    AjaxHubMulti: 50,
    AjaxWallAlarm: 51
}

export const deviceTypes = {
    0: () => '',
    [deviceTypesInv.TwigProtector]: () => 'Twig Protector',
    [deviceTypesInv.TwigProtectorPro]: () => 'Twig Protector Pro',
    [deviceTypesInv.TwigProtectorEX]: () => 'Twig Protector EX',
    [deviceTypesInv.TwigProtectorProEX]: () => 'Twig Protector Pro EX',
    [deviceTypesInv.TwigEmbody]: () => 'Twig Embody',
    [deviceTypesInv.TwigSOSCard]: () => 'Twig SOS card P4',
    [deviceTypesInv.TwigProtectorProOld]: () => 'Twig Protector (TUP90EU)',
    [deviceTypesInv.TeltonikaTMT250Old]: () => 'Teltonika TMT250',
    [deviceTypesInv.TeltonikaGH5200]: () => 'Teltonika GH5200',
    [deviceTypesInv.Generic]: (t) => t ? t('deviceType.generic') : 'Generic',
    [deviceTypesInv.App]: (t) => t ? t('deviceType.app') : 'App',
    [deviceTypesInv.TeltonikaTMT250]: () => 'Teltonika TMT250',
    [deviceTypesInv.TwigOne]: () => 'Twig One',
    [deviceTypesInv.WebUser]: () => '',
    [deviceTypesInv.MoxaE12010]: () => 'I/O',
    [deviceTypesInv.TwigNeo]: () => 'Twig Neo',
    [deviceTypesInv.TwigNeoEx]: () => 'Twig Neo Ex',
    [deviceTypesInv.TwigOneEx]: () => 'Twig One Ex',
    [deviceTypesInv.EmeritEWG100]: () => 'Emerit e-WG100',
    [deviceTypesInv.EmeritEWG200]: () => 'Emerit e-WG200',
    [deviceTypesInv.ESPA]: () => 'ESPA 4.4.4 Gateway',
    [deviceTypesInv.ESPA2]: () => 'ESPA 4.4.4 Gateway v2',
    [deviceTypesInv.TwigRemoteButton]: () => 'Twig Remote Button',
    [deviceTypesInv.TwigSOSCardP5]: () => 'Twig SOS card P5',
    [deviceTypesInv.EviewEV04]: () => 'Eview EV-04',
    [deviceTypesInv.EviewEV06]: () => 'Eview EV-06',
    [deviceTypesInv.EviewEV12]: () => 'Eview EV-12',
    [deviceTypesInv.AjaxHubMulti]: () => 'Ajax Hub Multi',
    [deviceTypesInv.AjaxWallAlarm]: () => 'Ajax Wall Alarm',
    [deviceTypesInv.QueclinkGL320M]: () => 'Queclink GL320M',
    [deviceTypesInv.TeltonikaFMC640]: () => 'Teltonika FMC640',
    [deviceTypesInv.TeltonikaFMC650]: () => 'Teltonika FMC650',
    [deviceTypesInv.TwigEasy5]: () => 'Twig Easy (P5)',
    [deviceTypesInv.EmeritConnect]: () => 'Emerit Connect App',
    [deviceTypesInv.EmeritERG170]: () => 'Emerit e-RG170',
    [deviceTypesInv.EmeritERG360]: () => 'Emerit e-RG360',
    [deviceTypesInv.EmeritERG530]: () => 'Emerit e-RG530',
    [deviceTypesInv.EmeritERG650]: () => 'Emerit e-RG650',
    [deviceTypesInv.EmeritERG655]: () => 'Emerit e-RG655',
    [deviceTypesInv.EmeritEIS330]: () => 'Emerit e-IS330',
    [deviceTypesInv.EmeritEIS530]: () => 'Emerit e-IS530',
    [deviceTypesInv.EmeritEIS655]: () => 'Emerit e-IS655',
    [deviceTypesInv.TwigEasy4]: () => 'Twig Easy (P4)',
    [deviceTypesInv.TwigEon]: () => 'Twig Eon',
    [deviceTypesInv.MobileAppLite]: () => 'Mobile App Lite',
};
export const realDeviceTypes = {
    0: () => '',
    [deviceTypesInv.TwigProtector]: () => 'Twig Protector',
    [deviceTypesInv.TwigProtectorPro]: () => 'Twig Protector Pro',
    [deviceTypesInv.TwigProtectorEX]: () => 'Twig Protector EX',
    [deviceTypesInv.TwigProtectorProEX]: () => 'Twig Protector Pro EX',
    [deviceTypesInv.TwigEmbody]: () => 'Twig Embody',
    [deviceTypesInv.TwigSOSCard]: () => 'Twig SOS card P4',
    [deviceTypesInv.TwigProtectorProOld]: () => 'Twig Protector (TUP90EU)',
    [deviceTypesInv.TeltonikaTMT250Old]: () => 'Teltonika TMT250 < FW55',
    [deviceTypesInv.TeltonikaGH5200]: () => 'Teltonika GH5200',
    [deviceTypesInv.Generic]: (t) => t ? t('deviceType.generic') : 'Generic',
    [deviceTypesInv.App]: (t) => t ? t('deviceType.app') : 'App',
    [deviceTypesInv.TeltonikaTMT250]: () => 'Teltonika TMT250',
    [deviceTypesInv.TwigOne]: () => 'Twig One',
    [deviceTypesInv.WebUser]: () => 'Web',
    [deviceTypesInv.MoxaE12010]: () => 'I/O',
    [deviceTypesInv.TwigNeo]: () => 'Twig Neo',
    [deviceTypesInv.TwigNeoEx]: () => 'Twig Neo Ex',
    [deviceTypesInv.TwigOneEx]: () => 'Twig One Ex',
    [deviceTypesInv.EmeritEWG100]: () => 'Emerit e-WG100',
    [deviceTypesInv.EmeritEWG200]: () => 'Emerit e-WG200',
    [deviceTypesInv.ESPA]: () => 'ESPA 4.4.4 Gateway',
    [deviceTypesInv.ESPA2]: () => 'ESPA 4.4.4 Gateway v2',
    [deviceTypesInv.TwigRemoteButton]: () => 'Twig Remote Button',
    [deviceTypesInv.TwigSOSCardP5]: () => 'Twig SOS card P5',
    [deviceTypesInv.EviewEV04]: () => 'Eview EV-04',
    [deviceTypesInv.EviewEV06]: () => 'Eview EV-06',
    [deviceTypesInv.EviewEV12]: () => 'Eview EV-12',
    [deviceTypesInv.AjaxHubMulti]: () => 'Ajax Hub Multi',
    [deviceTypesInv.AjaxWallAlarm]: () => 'Ajax Wall Alarm',
    [deviceTypesInv.QueclinkGL320M]: () => 'Queclink GL320M',
    [deviceTypesInv.TeltonikaFMC640]: () => 'Teltonika FMC640',
    [deviceTypesInv.TeltonikaFMC650]: () => 'Teltonika FMC650',
    [deviceTypesInv.TwigEasy5]: () => 'Twig Easy (P5)',
    [deviceTypesInv.EmeritConnect]: () => 'Emerit Connect App',
    [deviceTypesInv.EmeritERG170]: () => 'Emerit e-RG170',
    [deviceTypesInv.EmeritERG360]: () => 'Emerit e-RG360',
    [deviceTypesInv.EmeritERG530]: () => 'Emerit e-RG530',
    [deviceTypesInv.EmeritERG650]: () => 'Emerit e-RG650',
    [deviceTypesInv.EmeritERG655]: () => 'Emerit e-RG655',
    [deviceTypesInv.EmeritEIS330]: () => 'Emerit e-IS330',
    [deviceTypesInv.EmeritEIS530]: () => 'Emerit e-IS530',
    [deviceTypesInv.EmeritEIS655]: () => 'Emerit e-IS655',
    [deviceTypesInv.TwigEasy4]: () => 'Twig Easy (P4)',
    [deviceTypesInv.TwigEon]: () => 'Twig Eon',
    [deviceTypesInv.MobileAppLite]: () => 'Mobile App Lite',
};
const manufacturers = {
    'elexol': {
        name: 'Elexol',
        deviceTypes: [
            deviceTypesInv.ESPA,
            deviceTypesInv.ESPA2
        ]
    },
    'twig': {
        name: 'Twig',
        deviceTypes: [
            deviceTypesInv.TwigProtector,
            deviceTypesInv.TwigProtectorPro,
            deviceTypesInv.TwigProtectorEX,
            deviceTypesInv.TwigProtectorProEX,
            deviceTypesInv.TwigEmbody,
            deviceTypesInv.TwigSOSCard,
            deviceTypesInv.TwigProtectorProOld,
            deviceTypesInv.TwigOne,
            deviceTypesInv.TwigNeo,
            deviceTypesInv.TwigNeoEx,
            deviceTypesInv.TwigOneEx,
            deviceTypesInv.TwigRemoteButton,
            deviceTypesInv.TwigSOSCardP5,
            deviceTypesInv.TwigEasy5,
            deviceTypesInv.TwigEasy4,
            deviceTypesInv.TwigEon
        ]
    },
    'teltonika': {
        name: 'Teltonika',
        deviceTypes: [
            deviceTypesInv.TeltonikaTMT250Old,
            deviceTypesInv.TeltonikaGH5200,
            deviceTypesInv.TeltonikaTMT250,
            deviceTypesInv.TeltonikaFMC640,
            deviceTypesInv.TeltonikaFMC650
        ]
    },
    'queclink': {
        name: 'Queclink',
        deviceTypes: [
            deviceTypesInv.QueclinkGL320M
        ]
    },
    'emerit': {
        name: 'Emerit',
        deviceTypes: [
            deviceTypesInv.EmeritConnect,
            deviceTypesInv.EmeritEWG100,
            deviceTypesInv.EmeritEWG200,
            deviceTypesInv.EmeritERG170,
            deviceTypesInv.EmeritERG360,
            deviceTypesInv.EmeritERG530,
            deviceTypesInv.EmeritERG650,
            deviceTypesInv.EmeritERG655,
            deviceTypesInv.EmeritEIS330,
            deviceTypesInv.EmeritEIS530,
            deviceTypesInv.EmeritEIS655
        ]
    },
    'eview': {
        name: 'Eview GPS',
        deviceTypes: [
            deviceTypesInv.EviewEV04,
            deviceTypesInv.EviewEV06,
            deviceTypesInv.EviewEV12
        ]
    },
    'ajax': {
        name: 'Ajax',
        deviceTypes: [
            deviceTypesInv.AjaxHubMulti,
            deviceTypesInv.AjaxWallAlarm
        ]
    },
    'app': {
        name: 'Cuebly',
        deviceTypes: [
            deviceTypesInv.App,
            deviceTypesInv.MobileAppLite
        ]
    }
};
export const getManufacturer = (deviceTypeId) => {
    return Object.keys(manufacturers)
        .find(m => manufacturers[m].deviceTypes.indexOf(deviceTypeId) >= 0) || 'other';
};
export const getManufacturerName = (t, deviceTypeId) => {
    return manufacturers[getManufacturer(deviceTypeId)]?.name || t('other');
};

export const adminCannotAdd = [
    deviceTypesInv.WebUser,
    deviceTypesInv.App,
    deviceTypesInv.TwigRemoteButton
];
export const deprecated = [
    deviceTypesInv.TeltonikaTMT250Old,
    deviceTypesInv.TwigProtectorProOld,
];

// Device types that exist only in V4 (no V3 backend)
export const v4OnlyDeviceTypes = [
    deviceTypesInv.MobileAppLite,
    deviceTypesInv.EviewEV06,
    deviceTypesInv.EviewEV12,
    deviceTypesInv.AjaxHubMulti,
    deviceTypesInv.AjaxWallAlarm,
];

// V4-only hardware: creatable only where the V4 create path is reachable, i.e.
// a V4-native session. MobileAppLite is excluded — it has its own create branch
// that works from a V3 session too.
export const v4NativeOnlyDeviceTypes = [
    deviceTypesInv.EviewEV06,
    deviceTypesInv.EviewEV12,
    deviceTypesInv.AjaxHubMulti,
    deviceTypesInv.AjaxWallAlarm,
];

// V4 type string ↔ V3 pseudo deviceTypeId mappings
export const v4DeviceTypeMap = {
    'mobile-v2-lite': deviceTypesInv.MobileAppLite,
    'eview_ev06': deviceTypesInv.EviewEV06,
    'eview_ev12': deviceTypesInv.EviewEV12,
    // The reverse lookup has no registry fallback, so a V4 Ajax device needs these.
    'ajax_hub_multi': deviceTypesInv.AjaxHubMulti,
    'ajax_wall_alarm': deviceTypesInv.AjaxWallAlarm,
};
export const v4DeviceTypeInvMap = {
    [deviceTypesInv.MobileAppLite]: 'mobile-v2-lite',
    [deviceTypesInv.EviewEV06]: 'eview_ev06',
    [deviceTypesInv.EviewEV12]: 'eview_ev12',
    [deviceTypesInv.AjaxHubMulti]: 'ajax_hub_multi',
    [deviceTypesInv.AjaxWallAlarm]: 'ajax_wall_alarm',
};

// The V4 type string to create a given V3 type as. Our own pseudo ids win —
// they are not the registry's namespace, so an id it happens to reuse must not
// resolve to a different device. Real V3 ids fall through to the registry.
export function getV4TypeForV3TypeId(deviceTypeId) {
    const id = Number(deviceTypeId);
    if (v4DeviceTypeInvMap[id]) return v4DeviceTypeInvMap[id];
    return v4DeviceTypeDefs.find(d => Number(d.id) === id)?.name || null;
}

const v4ToV3DeviceTypeIdMap = {
    ...v4DeviceTypeMap,
    // Legacy mobile app — keep a migrated `app` device recognised as an App (isApp).
    'app': deviceTypesInv.App,
    'emerit_ewg100': deviceTypesInv.EmeritEWG100,
    'emerit_ewg200': deviceTypesInv.EmeritEWG200,
    'emerit_connect': deviceTypesInv.EmeritConnect,
    'emerit_erg170': deviceTypesInv.EmeritERG170,
    'emerit_erg360': deviceTypesInv.EmeritERG360,
    'emerit_erg530': deviceTypesInv.EmeritERG530,
    'emerit_erg650': deviceTypesInv.EmeritERG650,
    'emerit_erg655': deviceTypesInv.EmeritERG655,
    'emerit_eis330': deviceTypesInv.EmeritEIS330,
    'emerit_eis530': deviceTypesInv.EmeritEIS530,
    'emerit_eis655': deviceTypesInv.EmeritEIS655,
};

export function getV3TypeIdForV4Type(v4Type) {
    if (!v4Type) return 0;
    return v4ToV3DeviceTypeIdMap[v4Type] || 0;
}

export function prettifyV4Type(v4Type) {
    if (!v4Type) return '';
    return v4Type
        .split(/[_-]/)
        .filter(Boolean)
        .map(s => s.charAt(0).toUpperCase() + s.slice(1))
        .join(' ');
}

// --- V4 device type definitions cache (populated from GET /v1/devices/device-types) ---

let v4DeviceTypeDefs = [];

/**
 * Store V4 device type definitions fetched from the API.
 * Each definition has: { id, name, brand, ... }
 */
export function setV4DeviceTypeDefs(defs) {
    v4DeviceTypeDefs = defs || [];
}

export function getV4DeviceTypeDefs() {
    return v4DeviceTypeDefs;
}

/**
 * Get the brand string for a V4 device type (e.g. 'cuebly-mobile').
 * Looks up by type string (matching against id or name fields).
 */
export function getV4Brand(v4Type) {
    if (!v4Type) return null;
    const def = v4DeviceTypeDefs.find(d => d.id === v4Type || d.name === v4Type);
    return def?.brand || null;
}

/**
 * Check if a V4 device type is V4-only based on its brand.
 * Brands like 'cuebly-mobile' represent devices that only exist in V4.
 */
export function isV4OnlyBrand(brand) {
    return brand === 'cuebly-mobile';
}

/**
 * Check if a V4 device type string represents a V4-only device.
 * Uses the fetched device type definitions when available,
 * falls back to the hardcoded v4DeviceTypeMap.
 */
export function isV4OnlyType(v4Type) {
    if (!v4Type) return false;
    const brand = getV4Brand(v4Type);
    if (brand) return isV4OnlyBrand(brand);
    // Fallback to hardcoded map when device type defs aren't loaded yet
    return v4Type in v4DeviceTypeMap;
}